import api from '@/api/countries'

const state = () => ({
    countries: [],
    cities: [],
    flags: {},
    codes: {},
    iso2Codes: {},
})

export const getterTypes = {
    getCountries: '[countries] Get all countries',
    getCities: '[countries] Get all cities',
    getFlag: '[countries] Get selected flag',
    getCode: '[countries] Get selected code',
    getIso2: '[countries] Get selected iso2',
}

export const mutationTypes = {
    addCountries: '[countries] Push all countries',
    addCities: '[countries] Push all cities',
}

export const actionTypes = {
    getCountries: '[countries] Load all countries',
    getCities: '[countries] Load all cities',
}

const getters = {
    [getterTypes.getCountries]: ({ countries }) => countries,
    [getterTypes.getCities]: ({ cities }) => cities,
    [getterTypes.getFlag]: (state) => (flag) => state.flags[flag],
    [getterTypes.getCode]: (state) => (code) => state.codes[code] || '',
    [getterTypes.getIso2]: (state) => (countryName) =>
        state.iso2Codes[countryName] || '',
}

const mutations = {
    [mutationTypes.addCountries](state, { countries }) {
        const defaultCountries = [
            'Israel',
            'united states',
            'Canada',
            'united kingdom',
            'Switzerland',
            'Belgium',
            'Germany',
            'France',
        ]

        countries.forEach((country) => {
            const countryName = country.name.toLowerCase()
            state.codes = {
                ...state.codes,
                [countryName]: country.phonecode
                    ? `+${country.phonecode}`
                    : '',
            }
            state.iso2Codes = {
                ...state.iso2Codes,
                [countryName]: country.iso2 || '',
            }
            if (country.emoji) {
                state.flags = {
                    ...state.flags,
                    [countryName]: country.emoji,
                }
            }
        })

        state.countries = [
            ...defaultCountries,
            ...countries.map((country) => country.name),
        ]
    },
    [mutationTypes.addCities](state, cities) {
        state.cities = cities.map((city) => city.name)
    },
}

const actions = {
    [actionTypes.getCountries]({ commit, state }, search) {
        if (state.countries.length > 0 && !search) {
            return Promise.resolve(state.countries)
        }
        return new Promise((res, rej) => {
            api.countries
                .getCountries(search)
                .then(async (response) => {
                    const countries = response.countries || []
                    commit(mutationTypes.addCountries, {
                        countries,
                    })
                    res(state.countries)
                })
                .catch((error) => {
                    rej(error)
                })
        })
    },
    [actionTypes.getCities]({ commit, state }, country, search) {
        return new Promise((res, rej) => {
            const countryName = country.toLowerCase()
            const countryIso2 = state.iso2Codes[countryName]

            if (!countryIso2) {
                rej(new Error(`ISO2 code not found for country: ${country}`))
                return
            }

            api.countries
                .getCities(countryIso2, search)
                .then((response) => {
                    const cities = response.cities || []
                    commit(mutationTypes.addCities, cities)
                    res(state.cities)
                })
                .catch((error) => {
                    rej(error)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
